import clsx from 'clsx';
import { format } from 'date-fns';
import { useRouter } from 'next/router';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetSupplier } from '@/modules/workforce/Crew/apiHooks';
import Experience from '@/modules/workforce/Crew/components/Crews/CrewDetails/Experience';
import Header from '@/modules/workforce/Crew/components/Crews/CrewDetails/Header';
import Team from '@/modules/workforce/Crew/components/Crews/CrewDetails/Team';
import { ISuppliers } from '@/modules/workforce/Crew/types';
import Tabs from '@/shared/components/atoms/Tabs';
import { SingleQrCode } from '@/shared/components/molecules';
import { useAuth } from '@/shared/hooks/context/auth';

const TAB_QUERY_INDICATORE = 'supplier_tab';

const CrewDetails = () => {
  const { user } = useAuth();
  const { query } = useRouter();
  const { t } = useTranslation('common');

  const [onePerPage, setOnePerPage] = useState(false);

  const supplierData = useGetSupplier({
    supplierId: Number(query?.id),
    todayDate: format(new Date(), 'yyyy-MM-dd'),
  });

  // TODO: check has team logic
  const [filter, setFilter] = useState<
    ISuppliers.FilterProps<ISuppliers.IGetSupplierTeamMemberData>
  >({
    search: '',
    selectedRows: [],
    allpagesData: [],
    isSelectAll: false,
    hasTeam: false,
  });
  const qrcodeRef = useRef(null);

  return (
    <section className='flex flex-col gap-16'>
      <Header supplierData={supplierData} />
      <div className='w-full'>
        <div className='flex items-center justify-between '>
          <div className='w-full rounded-t-2xl border-xs border-neutralVariant-90 bg-background-neutral-99 p-16'>
            <Tabs
              activeClassName='!bg-blue-100'
              containerClassName='w-fit'
              tabClasseName='p-3'
              getLabel={(item: { id: string; name: string }) => item?.name}
              getValue={(item: { id: string; name: string }) => item?.id}
              tabsList={[
                {
                  id: '0',
                  name: t(
                    supplierData.data?.status === 'ACTIVE'
                      ? 'workers-list'
                      : 'archived-workers'
                  ),
                },
                {
                  id: '1',
                  name: t('general-info'),
                },
              ]}
              variant='connected'
              tabQueryIndicator={TAB_QUERY_INDICATORE}
              defaultValue='0'
            />
          </div>
        </div>

        {query?.[TAB_QUERY_INDICATORE] === '0' ? (
          <Team
            status={supplierData.data?.status ?? 'ACTIVE'}
            onePerPage={onePerPage}
            setOnePerPage={setOnePerPage}
            qrcodeRef={qrcodeRef}
            setFilter={setFilter}
            filter={filter}
          />
        ) : (
          <Experience />
        )}
        {/* printed qr codes */}
        <div className='hidden'>
          <div ref={qrcodeRef} className='block print:break-inside-avoid-page'>
            <div
              // TODO: remove this after testing
              className={clsx('gap-y-72', !onePerPage && 'grid grid-cols-3')}
            >
              {(filter.allpagesData.length !== 0
                ? filter.allpagesData
                : filter.selectedRows
              ).map((row) => (
                // TODO: remove this after testing
                <SingleQrCode
                  className={clsx(onePerPage && 'break-before-page')}
                  key={row.workerId}
                  variant='multiple'
                  qrData={{
                    qrCode: row?.qrCode,
                    name: row?.name,
                    logo: user?.companyLogo,
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { CrewDetails };
